import React from 'react';

export default function Icon({ icon, className = '', style = {}, alt = '' }) {
  const normalized = String(icon || '').replace(/^ph[- ]?/, '').trim();
  if (!normalized) return null;

  const tokens = String(className || '')
    .split(/\s+/)
    .map(token => token.trim())
    .filter(Boolean);

  if (!tokens.includes('icon')) {
    tokens.unshift('icon');
  }

  if (!tokens.includes(normalized)) {
    tokens.push(normalized);
  }

  const cls = [...new Set(tokens)].join(' ');

  return (
    <i
      className={cls}
      style={style}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
    />
  );
}
